var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 130,
    viewBox: "0 0 160 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9175 102.757L73.9637 30.9037C74.5805 30.0682 75.668 29.7293 76.6503 30.0665L77.6356 30.4047C96.5008 36.8809 109.982 53.5996 112.313 73.4089C112.425 74.3655 111.931 75.2913 111.074 75.7304L31.9465 116.259C31.1037 116.691 30.0738 116.472 29.4788 115.736L20.9706 105.202C20.3989 104.494 20.3771 103.489 20.9175 102.757Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 30.5C110.5 43.5 112 73.5 112 73.5C112 73.5 88 66 76 30.5Z",
    fill: "#E8F5FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.334 110.389C44.219 110.021 43.5 110.5 43.5 110.5C43.5 110.5 43.4452 110.466 43.334 110.389C42.9407 110.553 42.2307 110.885 41 111.5L37.5068 108.801C32.6132 105.019 28.9557 99.867 27 94L29 91.5C30.4934 94.5614 30.5 96.5 34.5 102.5C39.8349 107.872 42.6505 109.921 43.334 110.389Z",
    fill: "#E8F5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 30C78 40.9037 89.2 63.8689 112 74.5",
    stroke: "#008BFF",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 97C30.5 102 32.6522 106.75 41 112",
    stroke: "#008BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 92C31.5 99 35.1522 105.25 43.5 110.5",
    stroke: "#008BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 98.5C70.5 96.5 69 97 69 97C69 97 60.7029 93.2456 54.5 87C49.4657 81.931 45.9934 74.0614 44.5 71L42.5 74L45.5524 80.9769C48.0919 86.7815 52.7102 91.4268 58.5 94L66.5 98.5Z",
    fill: "#E8F5FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 82.5L99.5 80.5C99.5 80.5 77 68 75 61.5C69.9657 56.431 66.4934 47.0614 65 44L63 47C64.3173 52.2691 66.7751 57.1847 70.2 61.4L71.5 63L78.5 71L86.5 77.5L95.5 82.5Z",
    fill: "#E8F5FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74C45 81 50.5 88.5 59.5 94.5",
    stroke: "#008BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 55.5C74.5 69.5 86.5 78.5 96.5 83",
    stroke: "#008BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71.5C47 78.5 55.5 91.5 69.5 97",
    stroke: "#008BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43C67 50 76 69.5 99.5 80.5",
    stroke: "#008BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9175 102.757L73.9637 30.9037C74.5805 30.0682 75.668 29.7293 76.6503 30.0665L77.6356 30.4047C96.5008 36.8809 109.982 53.5996 112.313 73.4089C112.425 74.3655 111.931 75.2913 111.074 75.7304L31.9465 116.259C31.1037 116.691 30.0738 116.472 29.4788 115.736L20.9706 105.202C20.3989 104.494 20.3771 103.489 20.9175 102.757Z",
    stroke: "#008BFF",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43.5C90.3333 40.5 96 31.9 92 21.5",
    stroke: "#008BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 14,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#008BFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 61,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#008BFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 33,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#008BFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 49.0479C98.5 52.0479 105 53.5476 106.5 51.0476C108.877 47.0853 103.336 42.367 105 40.0476C107.525 36.5277 113.475 44.3481 116 41.5476C117.803 39.5472 115.241 36.172 114 32.86C112.918 29.9724 116.525 26.9849 119.41 30.8123",
    stroke: "#008BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 62.3136C108.833 59.8136 119.5 56.001 133 61.0008",
    stroke: "#008BFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.171 24L65.9568 26.2903L68 26.3721L66 27.3721L65.171 29.5237L64.5 27.3719L63 26.8721L64.5 26.3719L65.171 24Z",
    fill: "#008BFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.908 71L128.322 75.1463L132 75.2943L128.4 77.1047L126.908 81L125.7 77.1044L123 76.1995L125.7 75.294L126.908 71Z",
    fill: "#008BFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.029 47.3514L123.163 49.1754L124.006 51.0387L122.134 49.7442L119.674 50.0592L121.457 48.4056L121.265 46.822L122.427 47.9153L125.029 47.3514Z",
    fill: "#008BFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.687 30.3599L104.299 31.7174L104.926 33.1042L103.533 32.1408L101.702 32.3752L103.029 31.1444L102.886 29.9658L103.751 30.7796L105.687 30.3599Z",
    fill: "#008BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopper);
export default __webpack_public_path__ + "static/media/Popper.1da1e4150a0e0cf0a9b17999e21ee127.svg";
export { ForwardRef as ReactComponent };